var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10"},[_c('charging-point-list',{attrs:{"chargingPointTypeId":_vm.chargingPointType.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }